var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.7935,
    y: 60.093,
    width: 8.48828,
    height: 2.09302,
    rx: 1.04651,
    transform: "rotate(180 72.7935 60.093)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62.1831,
    y: 60.0931,
    width: 3.18311,
    height: 2.09302,
    rx: 1.04651,
    transform: "rotate(180 62.1831 60.0931)",
    fill: "white",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 23,
    width: 8.48828,
    height: 2.09302,
    rx: 1.04651,
    fill: "white",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.6104,
    y: 23,
    width: 3.18311,
    height: 2.09302,
    rx: 1.04651,
    fill: "white",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5969 35.5579C71.8779 35.8416 71.1193 35.253 71.2296 34.4969L71.669 31.4871C71.7796 30.7292 72.6801 30.3716 73.2888 30.8439L75.7119 32.7241C76.3205 33.1965 76.1802 34.1438 75.4594 34.4282L72.5969 35.5579Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10236 51.6364C9.10849 52.3995 8.27971 52.8801 7.60655 52.5038L4.92444 51.0043C4.24788 50.626 4.23595 49.6668 4.90299 49.28L7.56068 47.7387C8.22773 47.3519 9.07178 47.8286 9.07794 48.5956L9.10236 51.6364Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9731 46.4053C66.6429 46.4053 67.1858 45.8698 67.1858 45.2093C67.1858 44.5488 66.6429 44.0133 65.9731 44.0133C65.3034 44.0133 64.7605 44.5488 64.7605 45.2093C64.7605 45.8698 65.3034 46.4053 65.9731 46.4053ZM65.9731 47.3023C67.1451 47.3023 68.0952 46.3652 68.0952 45.2093C68.0952 44.0534 67.1451 43.1163 65.9731 43.1163C64.8012 43.1163 63.8511 44.0534 63.8511 45.2093C63.8511 46.3652 64.8012 47.3023 65.9731 47.3023Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3226 33.628C13.0645 32.6295 13.9988 31.7301 15.0046 32.0089C16.0107 32.2877 16.3337 33.5361 15.586 34.2559C14.8383 34.9756 13.5808 34.6268 13.3226 33.628Z",
    fill: "white",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_128_171)",
    filter: "url(#filter0_f_128_171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0379 34.2941H19.7521C19.1302 34.2941 18.7157 33.6639 18.923 33.0756L20.1252 29.5882C20.2495 29.2101 20.5812 29 20.9542 29H41.1841C42.0132 29 42.3862 30.0084 41.8059 30.5966L38.2822 33.916L26.675 44.7143C26.5092 44.8824 26.3019 44.9664 26.0532 44.9664H22.2393C21.4102 44.9664 21.0372 43.958 21.6175 43.3697L29.6182 35.8487C30.2401 35.3445 29.867 34.2941 29.0379 34.2941ZM22.4466 48.6639H34.3855C35.0073 48.6639 35.4219 49.2941 35.2146 49.8824L34.0539 53.3697C33.9295 53.7479 33.5979 53.958 33.2248 53.958H12.9121C12.2902 53.958 11.8757 53.3277 12.083 52.7395L12.2902 52.1092L12.5804 51.8571L15.5652 49.042L16.0212 48.6218L22.4466 48.6639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2482 52.5714C61.6213 53.1597 61.2067 53.958 60.502 53.958H54.7398L54.574 53.6639L49.6823 46.0588C49.3922 45.5966 48.8118 45.5126 48.3973 45.8067L46.2002 47.4454C46.0758 47.5714 45.9514 47.6975 45.8685 47.8655L44.0031 53.3697C43.8787 53.7479 43.5471 53.958 43.174 53.958H39.8576C39.2358 53.958 38.8213 53.3277 39.0285 52.7395L41.4329 45.6807C41.4743 45.5126 41.5987 45.3445 41.7645 45.2605L52.9573 36.8992L63.238 29.2101C63.4038 29.084 63.5696 29.042 63.7769 29.042H68.1711C69.0416 29.042 69.4147 30.1765 68.71 30.6807H68.5856L54.8642 40.9748C54.4911 41.2689 54.3667 41.8151 54.6569 42.1933L61.0823 52.2773L61.2482 52.5714ZM50.1798 35.0504L45.6613 38.4118C44.9565 38.958 43.9616 38.2017 44.2933 37.3613L46.9878 29.5882C47.1122 29.2101 47.4438 29 47.8169 29H51.1333C51.7551 29 52.1696 29.6303 51.9623 30.2185L50.4285 34.6303C50.47 34.7983 50.3456 34.9664 50.1798 35.0504Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_128_171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0379 34.2941H19.7521C19.1302 34.2941 18.7157 33.6639 18.923 33.0756L20.1252 29.5882C20.2495 29.2101 20.5812 29 20.9542 29H41.1841C42.0132 29 42.3862 30.0084 41.8059 30.5966L38.2822 33.916L26.675 44.7143C26.5092 44.8824 26.3019 44.9664 26.0532 44.9664H22.2393C21.4102 44.9664 21.0372 43.958 21.6175 43.3697L29.6182 35.8487C30.2401 35.3445 29.867 34.2941 29.0379 34.2941ZM22.4466 48.6639H34.3855C35.0073 48.6639 35.4219 49.2941 35.2146 49.8824L34.0539 53.3697C33.9295 53.7479 33.5979 53.958 33.2248 53.958H12.9121C12.2902 53.958 11.8757 53.3277 12.083 52.7395L12.2902 52.1092L12.5804 51.8571L15.5652 49.042L16.0212 48.6218L22.4466 48.6639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2482 52.5714C61.6213 53.1597 61.2067 53.958 60.502 53.958H54.7398L54.574 53.6639L49.6823 46.0588C49.3922 45.5966 48.8118 45.5126 48.3973 45.8067L46.2002 47.4454C46.0758 47.5714 45.9514 47.6975 45.8685 47.8655L44.0031 53.3697C43.8787 53.7479 43.5471 53.958 43.174 53.958H39.8576C39.2358 53.958 38.8213 53.3277 39.0285 52.7395L41.4329 45.6807C41.4743 45.5126 41.5987 45.3445 41.7645 45.2605L52.9573 36.8992L63.238 29.2101C63.4038 29.084 63.5696 29.042 63.7769 29.042H68.1711C69.0416 29.042 69.4147 30.1765 68.71 30.6807H68.5856L54.8642 40.9748C54.4911 41.2689 54.3667 41.8151 54.6569 42.1933L61.0823 52.2773L61.2482 52.5714ZM50.1798 35.0504L45.6613 38.4118C44.9565 38.958 43.9616 38.2017 44.2933 37.3613L46.9878 29.5882C47.1122 29.2101 47.4438 29 47.8169 29H51.1333C51.7551 29 52.1696 29.6303 51.9623 30.2185L50.4285 34.6303C50.47 34.7983 50.3456 34.9664 50.1798 35.0504Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_128_171",
    x: 2,
    y: 19,
    width: 77,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_128_171"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 25,
    fill: "white",
    transform: "translate(12 29)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_128_171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 25,
    fill: "white",
    transform: "translate(12 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout3);
export default __webpack_public_path__ + "static/media/about-3.eaf717f4fffb747ee8e5b44849292288.svg";
export { ForwardRef as ReactComponent };